import { render, staticRenderFns } from "./ProjectOrderWrapper.vue?vue&type=template&id=59669f6b&"
import script from "./ProjectOrderWrapper.vue?vue&type=script&lang=js&"
export * from "./ProjectOrderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports